
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';
import { SpacingSettings as SpacingType } from '@/utils/pdf-templates/types';

interface Props {
    spacing: SpacingType;
    onChange: (val: SpacingType) => void;
}

export function SpacingSettings({ spacing, onChange }: Props) {
    const update = (key: keyof SpacingType, value: number) => {
        onChange({ ...spacing, [key]: value });
    };

    const items: { key: keyof SpacingType; label: string }[] = [
        { key: 'pageMarginTop', label: 'هامش أعلى' },
        { key: 'pageMarginRight', label: 'هامش يمين' },
        { key: 'pageMarginBottom', label: 'هامش أسفل' },
        { key: 'pageMarginLeft', label: 'هامش يسار' },
        { key: 'sectionGap', label: 'تباعد الأقسام' },
        { key: 'sectionPadding', label: 'حشوة القسم الداخلية' },
    ];

    return (
        <div className="space-y-5">
            {items.map(({ key, label }) => (
                <div key={key}>
                    <div className="flex justify-between mb-2">
                        <Label>{label}</Label>
                        <span className="text-sm text-muted-foreground font-mono">{spacing[key]}px</span>
                    </div>
                    <Slider min={0} max={80} step={2} value={[spacing[key]]} onValueChange={([v]) => update(key, v)} />
                </div>
            ))}
        </div>
    );
}
